import React from 'react'
import * as bie from "react-bootstrap";
import { ErrorMessage, Field, Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import Swal from 'sweetalert2';
import { failureAlert, successAlert2 } from './CommonUtils/SweetAlerts';
import { config } from './CommonUtils/CommonURLS';
import { CommonAxiosPost } from './CommonUtils/CommonAxios';
export default function ChangePassword() {
    const handleLogout = () => {

        // ✅ Clear session storage
        sessionStorage.clear();

        // ✅ Clear local storage
        localStorage.clear();

        // ✅ Clear all cookies (current domain)
        document.cookie.split(";").forEach(cookie => {
            document.cookie = cookie
                .replace(/^ +/, "")
                .replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
        });

        // ✅ Clear browser cache (if supported)
        if ("caches" in window) {
            caches.keys().then(names => {
                names.forEach(name => caches.delete(name));
            });
        }

        // ✅ Prevent back navigation
        window.history.pushState(null, "", window.location.href);
        window.onpopstate = () => {
            window.history.go(1);
        };

        // ✅ Redirect to login page
        window.location.replace("/");   // better than navigate()
    };
    ;

    const changepswFormik = useFormik({
        enableReinitialize: true,
        initialValues: {

            oldpassword: "",
            newpassword: "",
            renewpassword: "",
        },
        validationSchema: Yup.object({
            oldpassword: Yup.string()
                .required('Old password is required')
                .min(8, 'Password must be at least 8 characters'),
            newpassword: Yup.string()
                .required('New password is required')
                .min(8, 'Password must be at least 8 characters')
                .matches(/[0-9]/, 'Password must contain at least one numeric character')
                .matches(/[a-zA-Z]/, 'Password must contain at least one alphabetic character')
                .matches(/[@$!%*?&]/, 'Password must contain at least one special character')
                .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
                .matches(/[a-z]/, 'Password must contain at least one lowercase letter'),
            renewpassword: Yup.string()
                .required('Confirm new password is required')
                .oneOf([Yup.ref('newpassword')], 'Retype Password must match with  New Password')
        }),
        onSubmit: (val) => {

            console.log("Change Password Form Values:", val);
            Swal.fire({
                text: "Are you sure you want to Change Password?",
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Yes, Change it!",
                cancelButtonText: "No, cancel!",
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    const url = config.url.API_URL + "changePassword";
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === "01") {
                            successAlert2(res?.data?.sdesc)
                            handleLogout();

                        } else {
                            failureAlert(res?.data?.sdesc || "Failed to Change Password");
                        }
                    })
                }
            });
        },
    })


    return (
        <>
            <FormikProvider value={changepswFormik}>

                <Form onChange={changepswFormik?.handleChange} onSubmit={changepswFormik?.handleSubmit} className="form_adjust" >

                    <bie.Row className="px-2 pt-3 mb-3" >
                        <bie.Row>
                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>
                                <span className='field-mandatory' >Old Password</span>
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>
                                <Field type="text" name="oldpassword" className="form-control" />
                                <ErrorMessage name="oldpassword" component="div" className="text-error" />

                            </bie.Col>
                        </bie.Row>
                        <bie.Row>

                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>
                                <span className='field-mandatory'>New Password</span>
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>

                                <Field type='text' name="newpassword" className='form-control' />
                                <ErrorMessage name="newpassword" component="div" className="text-error" />
                            </bie.Col>
                        </bie.Row>
                        <bie.Row>
                            <bie.Col xs={12} sm={12} md={12} lg={2} xl={2} xxl={2} className='mb-2'>
                                <span className='field-mandatory'>Retype New Password</span>
                            </bie.Col>
                            <bie.Col xs={12} sm={12} md={12} lg={3} xl={3} xxl={3} className='mb-2'>

                                <Field type='text' name="renewpassword" className='form-control' />
                                <ErrorMessage name="renewpassword" component="div" className="text-error" />
                            </bie.Col>
                        </bie.Row>


                        <div>
                            <ul>
                                <li>Password must be at least 8 characters.</li>
                                <li>Must have at least one numeric, one alphabet, and one special character.</li>
                                <li>Must have at least one uppercase and one lowercase character.</li>
                            </ul>
                        </div>
                        <div className="d-flex flex-row justify-content-end pb-4">

                            <button type="submit" className="btn btn-primary btn-sm rounded" >
                                Reset Password
                            </button> &emsp;


                        </div>
                    </bie.Row>
                </Form>

            </FormikProvider >



        </>
    )
}
